module.exports = __webpack_public_path__ + "static/img/wechat-pay-help.b902f554.png";